import type { HighlightsOverview, HighlightView } from "./Highlight";

// Все моменты раздела «Хайлайты» по одному разу: моменты матчей и готовые клипы для полосы
// на главной (готовый клип приходит и там и там).
export const overviewItems = (overview: HighlightsOverview): HighlightView[] => {
  const seen = new Set<number>();
  return [...overview.matches.flatMap((match) => match.items), ...overview.ready].filter(
    (highlight) => {
      if (seen.has(highlight.id)) {
        return false;
      }
      seen.add(highlight.id);
      return true;
    },
  );
};
